/**
 * Was ist neu — die Quelle für das Popup und für „Was ist neu" in den
 * Einstellungen. Neueste Version steht oben.
 *
 * Eine neue Version ausrollen: hier einen Eintrag ergänzen (und die Version in
 * der Root-`package.json` anheben). Das Popup zeigt sich erneut, sobald die
 * `version` des obersten Eintrags von der zuletzt gesehenen abweicht — der
 * Build-Zeitstempel allein löst es nicht aus.
 */
export interface ReleaseNote {
  /** Muss zur Version in der Root-`package.json` passen. */
  version: string
  /** Tag der Freigabe, ISO (`YYYY-MM-DD`). */
  date: string
  /** Kurze Stichpunkte in der Sprache der Oberfläche. */
  changes: string[]
}

export const RELEASE_NOTES: ReleaseNote[] = [
  {
    version: '1.1.0',
    date: '2026-09-27',
    changes: [
      'Prompts sind beim Öffnen sofort da: die Liste wird lokal gemerkt und im Hintergrund aktualisiert.',
      'Der Hinweis im leeren Chat bleibt stehen, auch wenn noch keine Prompts geladen sind.',
      'Antwortet der Server nicht, bleiben die zuletzt geladenen Prompts nutzbar statt zu verschwinden.',
      'Das Add-in-Paket (ZIP) gibt es jetzt direkt beim Server unter /download — mit passender Adresse im Manifest.',
      'Version und Build-Datum stehen in den Einstellungen und in diesem Fenster.',
    ],
  },
]

/** Der oberste Eintrag — der, auf den sich das Popup bezieht. */
export const latestRelease: ReleaseNote | undefined = RELEASE_NOTES[0]

/** `27.09.2026` — oder der rohe Wert, wenn er nicht lesbar ist. */
export function formatReleaseDate(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  const p = (n: number) => String(n).padStart(2, '0')
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()}`
}
